module.exports = __webpack_public_path__ + "img/bank-aktif.6bcddfcb.svg";